import bnLcvRouteLanding from "../../../core/src/locales/bn/lcvRouteLanding.json";
import enLcvRouteLanding from "../../../core/src/locales/en/lcvRouteLanding.json";
import guLcvRouteLanding from "../../../core/src/locales/gu/lcvRouteLanding.json";
import hiLcvRouteLanding from "../../../core/src/locales/hi/lcvRouteLanding.json";
import knLcvRouteLanding from "../../../core/src/locales/kn/lcvRouteLanding.json";
import mrLcvRouteLanding from "../../../core/src/locales/mr/lcvRouteLanding.json";
import taLcvRouteLanding from "../../../core/src/locales/ta/lcvRouteLanding.json";
import teLcvRouteLanding from "../../../core/src/locales/te/lcvRouteLanding.json";

import { getLcvRouteBySlug } from "./data";
import { getLcvBookingRoutePath, LCV_BOOKING_ROUTE_SLUGS } from "./lcvRouteLanding.constants";

const LCV_ROUTE_LABELS_BY_LOCALE: Record<string, Record<string, string>> = {
    bn: bnLcvRouteLanding.footer.lcvRouteLabels,
    en: enLcvRouteLanding.footer.lcvRouteLabels,
    gu: guLcvRouteLanding.footer.lcvRouteLabels,
    hi: hiLcvRouteLanding.footer.lcvRouteLabels,
    kn: knLcvRouteLanding.footer.lcvRouteLabels,
    mr: mrLcvRouteLanding.footer.lcvRouteLabels,
    ta: taLcvRouteLanding.footer.lcvRouteLabels,
    te: teLcvRouteLanding.footer.lcvRouteLabels
};

export interface LcvFooterRouteAlternateLink {
    locale: string;
    label: string;
    path: string;
}

export interface LcvFooterRouteLinkGroup {
    slug: string;
    alternates: LcvFooterRouteAlternateLink[];
}

export const getLcvRouteLocalizedPath = (locale: string, slug: string) => {
    const basePath = getLcvBookingRoutePath(slug);
    return locale === "en" ? basePath : `/${locale}${basePath}`;
};

const getLcvRouteLabel = (locale: string, slug: string) =>
    LCV_ROUTE_LABELS_BY_LOCALE[locale]?.[slug] ?? LCV_ROUTE_LABELS_BY_LOCALE.en[slug];

export const getLcvRouteFooterLinkGroups = (): LcvFooterRouteLinkGroup[] =>
    LCV_BOOKING_ROUTE_SLUGS.map((slug) => {
        const locales = getLcvRouteBySlug(slug)?.hreflangLocales ?? ["en"];

        return {
            slug,
            alternates: locales.map((locale) => ({
                locale,
                label: getLcvRouteLabel(locale, slug),
                path: getLcvRouteLocalizedPath(locale, slug)
            }))
        };
    });
